<template>
<div class="side animate-box">
    <p><strong><h1 v-html="lang_detail['contact']"></h1></strong></p>
<p><strong><h2 v-html="content_detail['title']" ></h2></strong></p>

    <div v-if="returnmsg==''">
        <p> <span v-html="lang_detail['requiredDescription']"></span> (<span class="required_indicator">*</span>)</p>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="name" v-html="lang_detail['name']"></label>
                <input type="text" id="name" ref=name class="form-control" v-model="name" aria-label="Name" aria-required="true" @keypress="isLetterWithSpace($event)" >
            </div>
            <span id="name_validation_error" role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="emaill" v-html="lang_detail['email']"></label>
                <input type="email" ref="email" id="emaill" class="form-control" v-model="email" aria-label="Email" aria-required="true" @keypress="htmlfiveValidationErr($event)" >
            </div>
            <span id="email_validation_error" role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="message" v-html="lang_detail['message']"></label>
                <textarea id="message" ref="message" rows="20" cols="20" class="form-control" v-model="message" aria-label="Reason for inquiry" aria-required="true" maxlength="3000"></textarea>
            </div>
            <span id="message_validation_error" role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <input type="checkbox" id="fterms"  v-model="fterms" aria-required="true" ref="fterms" aria-label="Terms and conditions">&nbsp;<span v-html="lang_detail['terms_check']"  ></span>
            </div>
            <span id="fterms_validation_error" role="alert"></span>
        </div>
        <div class="row form-group">
            <p></p>
        </div>
        <div class="row form-group hhcap">
            <vue-hcaptcha :sitekey="$store.state.HC_SITE_KEY"  @verify="onVerify" @expired="onExpire" @error="onError"></vue-hcaptcha>
            <span id="hccaptcha_validation_error" role="alert"></span>
        </div>
       
        <div class="form-group">
            <button type="button" :disabled="disablefdbtn" class="btn submit btn-primary" @click="sendForm()" v-html="lang_detail['submit']"></button>
        </div>
    </div>
    <p v-else v-html="returnmsg" role="alert"></p>
</div>    
</template>

<script>
import axios from 'axios';
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
export default {
    name: 'WellCoach',
    data(){
        return{
            content_detail:[],
            lang_detail:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            languageData:this.$store.state.languageData,
            fterms:'',message:'',email:'',name:'',returnmsg:'',
            title:'',
            verified: false,
            expired: false,
            token: null,
            eKey: null,
            error: null,
            disablefdbtn:false
        };
        
    },
    components:{
       VueHcaptcha        
    },
    mounted :function(){
        this.showContent(this.$route.query.id),
        this.getlangVar()
        //this.showCentersBlock()
    },
    watch: {
        name: function() {
            this.validateFormRemoveMarkers('name_validation_error');               
        },               
        email: function() {
            this.validateFormRemoveMarkers('email_validation_error');               
        },               
        message: function() {
            this.validateFormRemoveMarkers('message_validation_error');               
        },        
        fterms: function() {
            this.validateFormRemoveMarkers('fterms_validation_error');               
        },
        verified: function() {
            this.validateFormRemoveMarkers('hccaptcha_validation_error');               
        }
    },
	methods:{
        sendForm(){
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            const formData = new FormData()
            formData.append('Name', this.name)
            formData.append('Email', this.email)
            formData.append('Message', this.message)
            formData.append('recid', this.$route.query.id)
            formData.append('title', this.content_detail['title'])
            formData.append('id_company', this.$store.state.companyData['id_company'])
            formData.append('id_language', this.$store.state.companyData['id_language'])
            formData.append('name_company', this.$store.state.companyData['name_company'])
            formData.append('id_country', this.$store.state.companyData['id_country'])
            formData.append('hc_token', this.token)
            formData.append('hc_eKey', this.eKey)
           
            var validateForm = this.validateForm(this.name,undefined,this.email,undefined,undefined,undefined,this.message,undefined,this.fterms,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,this.verified);
            if(!validateForm){
                this.disablefdbtn=true;
                axios.post(this.$store.state.FORM_ACTION_DOMAIN+'/new_eesite_forms/feedback_form.php',formData,config)
                .then(response => {
                    if(response === undefined || response.length == 0 ){
                        this.returnmsg='! Something went wrong, Please try again';
                    }
                    else{
                        this.returnmsg = response.data;
                    }
                })
                .catch(() => {
                    this.returnmsg='Try after sometime';
                });
            }
        },
        showContent(cr_id){
            var api_private_key=this.get_api_key_mix('cols')
            axios.get(this.$store.state.apiUrl+'/content_details',{
                params:{
                    id_cr:cr_id,
                    id_company:this.$store.state.companyData['id_company'],
                    id_language:this.$store.state.companyData['id_language'],
                    id_country:this.$store.state.companyData['id_country'],
                    privatekey:api_private_key                 
                }
            })
            .then(response => {              
                response = response.data
                this.content_detail = response[0]                
            })
            .catch(() => {
                this.main_content = []
            });
        },
        getlangVar(){
            document.querySelector('title').setAttribute("aria-busy", "true");
            var api_private_key=this.get_api_key_mix('lams')
            axios.get(this.$store.state.apiUrl+'/language_terms',{
                params:{
                    id_language:this.$store.state.companyData['id_language'],
                    privatekey:api_private_key,
                    id_company:this.$store.state.companyData['id_company'],
                    id_country:this.$store.state.companyData['id_country']        
                }
            })
            .then(response => {              
                response = response.data;
                this.lang_detail = response;
                var titleValue =this.lang_detail['feedback'];                
                var home = this.lang_detail['d00'];
                this.$announcer.set(this.decodeHtmlLang(titleValue)+' | '+this.$store.state.companyData['name_company']);
                document.title = this.decodeHtmlLang(titleValue)+' | '+this.$store.state.companyData['name_company'];           
            })
            .catch(() => {
                this.main_content = []
            });
        },
        onVerify(token, ekey) {
            this.verified = true;
            this.token = token;
            this.eKey = ekey;
            console.log(`hcCallback token: ${token}, ekey: ${ekey}`);
        },
        onExpire() {
            this.verified = false;
            this.token = null;
            this.eKey = null;
            this.expired = true;
            console.log('hcExpired');
        },
        onError(err) {
            this.token = null;
            this.eKey = null;
            this.error = err;
            console.log(`hcError: ${err}`);
        }

    }
};
</script>
<style scoped>
.form-group{
    margin-bottom: 40px;
}
.dynamic_form_error_required{
    padding-left:15px !important;
    color:#FF0000 !important;    
}
.required_indicator {
    font-family: Verdana;
    font-size: 14px;
    color: red;
}
.hhcap{
    padding-left: 1em;
}
</style>